import { Box } from "@mui/material";
import Header from "../../components/Header";
import BarChart from "../../components/BarChart";
import WeeklyDates from "./dates";


const Bar = () => {
  return (
    <Box m="20px">
      <Header title="Bar Chart" subtitle="Weekly Bar Chart Revenue Report" />
      <WeeklyDates />
      <Box height="75vh">
        <BarChart />
      </Box>
    </Box>
  );
};

export default Bar;